import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThinUp = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M4 20C4 20.5522 4.44775 21 5 21C5.28813 21 5.54713 20.8774 5.72963 20.6824C5.732 20.68 16 9.47987 16 9.47987C16 9.47987 26.268 20.68 26.2704 20.6824C26.4529 20.8774 26.7118 21 27 21C27.5523 21 28 20.5523 28 20C28 19.7434 27.9025 19.51 27.7435 19.333C27.7411 19.3303 16.7371 7.32425 16.7371 7.32425C16.5476 7.11775 16.2803 7 16 7C15.7198 7 15.4523 7.11762 15.2629 7.32425C15.2629 7.32425 4.25888 19.3302 4.2565 19.333C4.0975 19.5101 4 19.7434 4 20V20Z" />
	</svg>
);

export default ChevronThinUp;
